import config from "environment";
import { getRequest, postRequest } from "./client";
import { UpdateMessageContentContract } from "winslow-core";

const { baseApi } = config;

export const apiUpdateMessageContent = async (payload: UpdateMessageContentContract["Body"]) => {
  const fetchURL = `${baseApi}/messages/update-content`;
  return await postRequest(fetchURL, payload, "API/apiUpdateMessageContent");
};
